import React from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  getTheme,
  mergeStyleSets,
  PrimaryButton,
  Text,
} from "@fluentui/react";

const dialogContentProps = {
  type: DialogType.normal,
  title: "Update Snippet",
};

const getClassNames = (theme) =>
  mergeStyleSets({
    description: {
      display: "inline-block",
      fontWeight: "bold",
    },
    footer: {
      marginTop: theme.spacing[12],
    },
    cancelBtn: {
      color: theme.palette.themePrimary,
      border: `2px solid ${theme.palette.themePrimary}`,
    },
    updateBtn: {
      background: theme.palette.themePrimaryLight,
      border: `1px solid ${theme.palette.themePrimaryLight}`,
      color: theme.palette.white,
    },
  });

const UpdateSnippetDialog = ({ open, handleOpen, onUpdate, snippetDescription }) => {
  let theme = getTheme();
  let { description, footer, cancelBtn, updateBtn } = getClassNames(theme);
  return (
    <Dialog hidden={!open} onDismiss={() => handleOpen(false)} dialogContentProps={dialogContentProps}>
      <Text variant="mediumPlus">
        Are you sure you want to update snippet: <div className={description}>{snippetDescription}</div>?
      </Text>
      <DialogFooter className={footer}>
        <DefaultButton className={cancelBtn} onClick={() => handleOpen(false)} text="Cancel" />
        <PrimaryButton className={updateBtn} onClick={onUpdate} text="Update" />
      </DialogFooter>
    </Dialog>
  );
};

export default UpdateSnippetDialog;
